import { breakpoints } from '@theme/breakpoints';
import { rem } from 'polished';
import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .submittedText {
    font-weight: 700;
    font-size: 1.8rem;
  }

  @media (${breakpoints.tablet}) {
    max-width: ${rem(1200)};
    margin: 0 auto;
  }

  .howWeUseYourDataText {
    margin: 2rem;
    text-align: left;
    @media ${breakpoints.smallDesktop} {
      max-width: 800px;
    }
  }

  [class*='StyledCheckoutCheckbox'] {
    padding-left: 2rem;
  }

  [class*='StyledButtonRow'] {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  [class*='FakeInput'] {
    margin-top: 1rem;
    max-width: unset;
  }
  .stuck-in-address-container {
    @media ${breakpoints.tablet} {
      margin-top: 1rem;
      max-width: 800px;
    }
  }
  .stuck-in-show-address {
    box-shadow: inset 0 1px 6px #ada9fb83;
    border-radius: 8px;
    border: solid 2px transparent;
  }
`;
